<template>
  <div class="password-check">
    <div class="box-center">
      <div class="ta-c fw-b fs-18 mb-10">
        <p>进入该页面需要验证二级密码</p>
      </div>
      <secondary-pwd-component @successCb="secondarySuccessCb"></secondary-pwd-component>      
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {Req_CheckNeedSecondary} from '@/request/organize'
import secondaryPwdComponent from '@/components/Finance/secondaryPwdComponent.vue'
export default {
  data() {
    return {
      showPage:true,
      toPath:''
    }
  },
  created() {
    // this.checkIsNeedSecond()
  },
  mounted() {
    this.checkIsNeedSecond()
  },
  methods: {
    ...mapMutations(['clearNeedSecondMenu','setShowCheckPassword']),
    checkIsNeedSecond(){
      Req_CheckNeedSecondary({platformType:20}).then(res => {
        if(res || !sessionStorage.getItem('secondPasswordIsPass')){
          this.showPage = true
        }
      }).catch(err => {
        this.$message.error('发生未知错误，请重新进入该页面')
        this.$router.push({path:'/'})
      })
    },
    secondarySuccessCb(){
      this.setShowCheckPassword(false)
    }
  },
  components:{
    secondaryPwdComponent
  }
}
</script>
<style lang="scss" scoped>
.password-check {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999999;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Account/passwordCheck.vue